import environment from 'environment';

class HTTPService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
    this.apiUrl = environment.API_URL;
  }

  get(url, responseType = 'json') {
    return this.sendRequest('GET', url, null, responseType);
  }
  
  /**
   * This is a quickfix for bet details loading inside a modal.
   * It is somehow very weird that it doesn't behave like any
   * other functions that uses get() with async.
   * 
   * TODO: Refactor BetHistoryController to get rid of this method.
   */
  getNonAsync(url, responseType = 'json') {
    return this.sendRequest('GET', url, null, responseType);
  }

  post(url, payload, responseType = 'json', additionalHeaders = {}) {
    return this.sendRequest('POST', url, payload, responseType, additionalHeaders);
  }

  put(url, payload) {
    return this.sendRequest('PUT', url, payload);
  }

  buildQueryParamsFromPayload(payload) {
    const encode = encodeURIComponent;

    return Object.keys(payload)
    .map((k) => {
      if (payload[k] !== '' && payload[k] !== null && typeof payload[k] != 'undefined') {
        return encode(k) + '=' + encode(payload[k]);
      }

      return '';
    })
    .filter(part => part || part.length > 0)
    .join('&')
    ;
  }

  sendRequest(method, url, payload = null, responseType = 'json', additionalHeaders = {}) {
    let requestUrl = this.apiUrl + url;
    let headers = {
      'Accept': 'application/json',
    };

    if (method !== 'GET') {
      headers['X-CSRF-Protection'] = '1';
    }

    return this.$http({
      method: method,
      url: requestUrl,
      data: payload,
      headers: angular.merge(headers, additionalHeaders),
      withCredentials: true,
      responseType: responseType,
    });
  }
}

export default HTTPService;



// WEBPACK FOOTER //
// ./client/app/shared/http/http.service.js